<template>
  <div class="search-pagination">
    <button
      :disabled="pageIndex <= 0"
      class="btn btn-link btn-previous"
      aria-label="Previous page"
      @click="previousPage()">
      <font-awesome-icon icon="chevron-left"
                         transform="down-1"></font-awesome-icon>
      Previous
    </button>

    <ol class="search-pagination__pages">
      <li v-for="index in pageCount"
          :key="index"
          class="search-pagination__item">
        <button
          :class="['btn btn-link', { active: index === selectedPage }]"
          :aria-label="`Select page ${index}`"
          @click="selectPage(index)">
          {{ index }}
        </button>
      </li>
    </ol>

    <button
      :disabled="pageIndex >= pageCount - 1"
      class="btn btn-link btn-next"
      aria-label="Next page"
      @click="nextPage()">
      Next
      <font-awesome-icon icon="chevron-right"
                         transform="down-1"></font-awesome-icon>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    enableScrolling: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedPage: 0
    };
  },
  computed: {
    pageNumber () {
      return this.pageIndex + 1;
    },
    pageCount () {
      return Math.ceil( this.resultCount / this.itemsPerPage );
    },
    availablePages () {
      return Array.from( new Array( this.pageCount ), ( x, i ) => String( i + 1 ) );
    },
    ...mapState( {
      pageIndex: state => state.search.pageIndex,
      itemsPerPage: state => state.search.itemsPerPage,
      resultCount: state => state.search.resultCount
    } )
  },
  watch: {
    pageNumber ( newValue ) {
      this.selectedPage = newValue;
    }
  },
  created () {
    this.selectedPage = this.pageNumber;
  },
  methods: {
    nextPage () {
      const payload = {
        pageIndex: this.pageIndex + 1,
        scrollToTop: this.enableScrolling
      };

      this.$store.dispatch( "paginate", payload );
    },
    previousPage () {
      const payload = {
        pageIndex: this.pageIndex - 1,
        scrollToTop: this.enableScrolling
      };

      this.$store.dispatch( "paginate", payload );
    },
    changePage () {
      const payload = {
        pageIndex: this.selectedPage - 1,
        scrollToTop: this.enableScrolling
      };

      this.$store.dispatch( "paginate", payload );
    },
    selectPage ( value ) {
      this.selectedPage = value;
      this.changePage();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.search-pagination {
  margin-top: 5px;
  padding: 10px;
  display: flex;
  width: 100%;
  justify-content: center;

  .btn {
    padding: 5px 10px;
    color: @color-accent-1;
    margin-right: 5px;

    &.active {
      background: #fff;
      border: 2px solid @color-accent-1;

      &:hover {
        text-decoration: none;
      }
    }
  }

  &__pages {
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    list-style-type: none;
  }

  .btn-next,
  .btn-previous {
    font-size: 14px;
    min-width: 120px;
  }

  .btn-previous {
    text-align: right;
  }

  .btn-next {
    text-align: left;
  }
}
</style>
